import _ from 'lodash';

import { handleErrors } from './ErrorActions';
import {
  bulkTranslateString,
  fetchSystemTranslations,
  changeLanguage as performChangeLanguage,
} from '../api/translations';
import { PENDING_TRANSLATIONS_KEY_LIST } from '../constants/Common';
import { getNetworkStatus } from '../form-designer/selectors/common.selectors';

export const ADD_TRANSLATIONS = 'ADD_TRANSLATIONS';
export const ADD_ENTITY_RESOLVER_RULES = 'ADD_ENTITY_RESOLVER_RULES';
export const GET_SYSTEM_TRANSLATIONS = 'GET_SYSTEM_TRANSLATIONS';
export const SET_TRANSLATED_STRING = 'SET_TRANSLATED_STRING';
export const BULK_TRANSLATE_STRING_PENDING = 'BULK_TRANSLATE_STRING_PENDING';
export const BULK_TRANSLATE_STRING_LOAD_FAILED = 'BULK_TRANSLATE_STRING_LOAD_FAILED';

export function addTranslations(translations) {
  return {
    type: ADD_TRANSLATIONS,
    translations,
  };
}

export function addEntityResolverRules(entityResolverRules) {
  return {
    type: ADD_ENTITY_RESOLVER_RULES,
    entityResolverRules,
  };
}

export function getSystemTranslations() {
  return async (dispatch, getState) => {
    const state = getState();
    let translations = _.get(state, ['translations', 'system']);

    if (!_.isNil(translations)) {
      return;
    }

    translations = await fetchSystemTranslations();

    dispatch({
      type: GET_SYSTEM_TRANSLATIONS,
      payload: translations,
    });
  };
}

export function getTranslationByKey(key, translations) {
  let translatedString = null;

  for (const translationsKey of ['system', 'Entity', 'Form', 'cached']) {
    translatedString = _.get(translations, [translationsKey, key]);

    if (!_.isNil(translatedString)) {
      break;
    }
  }

  return translatedString;
}

export const getIsTranslationsLoaded = (state) => {
  return state.translations.isLoaded;
};

let apiTimeout;

export const clearPendingKeyList = (responseKeys) => {
  responseKeys.forEach((key) => {
    const globalIndex = PENDING_TRANSLATIONS_KEY_LIST.findIndex((globalKey) => globalKey === key);

    PENDING_TRANSLATIONS_KEY_LIST.splice(globalIndex, 1);
  });
};

export const getTranslatedKey = (key) => async (dispatch, getState) => {
  const isOnline = getNetworkStatus(getState());

  if (_.isNil(key) || !isOnline) {
    return;
  }

  clearTimeout(apiTimeout);
  //add translation to the pending key list
  PENDING_TRANSLATIONS_KEY_LIST.push(key);

  apiTimeout = setTimeout(async () => {
    dispatch({
      type: BULK_TRANSLATE_STRING_PENDING,
    });

    const result = await bulkTranslateString(PENDING_TRANSLATIONS_KEY_LIST);

    if (_.isNil(result) || _.isNil(result.Translations)) {
      return;
    }

    //clear pending key list array
    clearPendingKeyList(Object.keys(result.Translations));

    dispatch({
      type: SET_TRANSLATED_STRING,
      payload: result.Translations,
    });
  }, 1000);
};

export const changeLanguage = (language) => async (dispatch) => {
  try {
    const { token, culture, hasError, errors } = await performChangeLanguage(language);

    if (hasError) {
      throw errors;
    }

    token && localStorage.setItem('token', token);
    culture && localStorage.setItem('culture', culture);
    window.location.reload();
  } catch (error) {
    dispatch(handleErrors(error, { isTopBanner: true }));
  }
};
